import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SearchBarModel {
  readonly searchText = signal($localize`搜尋關鍵字`);
}
